import { EditorQueries, useEditor } from '@candulabs/craft';

import { Resolver } from 'craft/types';

export const useResolver = (type?: string): Resolver | undefined => {
  const { query } = useEditor();
  if (!type) {
    return undefined;
  }
  const resolver = query.getResolver();
  return resolver[type];
};

export const getResolver = (query: EditorQueries, type?: string): Resolver | undefined => {
  if (!type) {
    return undefined;
  }
  const resolver = query.getResolver();
  return resolver[type];
};
